export enum EngagementProcessStatus {
    Prospective = 0,
    Current = 1,
    Suspended = 2,
    Terminated = 3,
    Completed = 4,
}

export const EngagementProcessStatuses = [
    { id: EngagementProcessStatus.Prospective, name: 'Prospective' },
    { id: EngagementProcessStatus.Current, name: 'Current' },
    { id: EngagementProcessStatus.Suspended, name: 'Suspended' },
    { id: EngagementProcessStatus.Terminated, name: 'Terminated' },
    { id: EngagementProcessStatus.Completed, name: 'Completed' },
];

export const EngagementProcessTransitions = new Map([
    [
        EngagementProcessStatus.Prospective,
        new Set([
            EngagementProcessStatus.Prospective,
            EngagementProcessStatus.Current,
            EngagementProcessStatus.Suspended,
            EngagementProcessStatus.Terminated,
        ]),
    ],
    [
        EngagementProcessStatus.Current,
        new Set([
            EngagementProcessStatus.Current,
            EngagementProcessStatus.Prospective,
            EngagementProcessStatus.Suspended,
            EngagementProcessStatus.Terminated,
        ]),
    ],
    [
        EngagementProcessStatus.Suspended,
        new Set([
            EngagementProcessStatus.Suspended,
            EngagementProcessStatus.Current,
            EngagementProcessStatus.Terminated,
        ]),
    ],
    [
        EngagementProcessStatus.Completed,
        new Set([EngagementProcessStatus.Completed]),
    ],
    [
        EngagementProcessStatus.Terminated,
        new Set([EngagementProcessStatus.Terminated]),
    ],
]);

export const EngagementProcessStatusOptions = {
    [EngagementProcessStatus.Prospective]: 'Prospective',
    [EngagementProcessStatus.Current]: 'Current',
    [EngagementProcessStatus.Suspended]: 'Suspended',
    [EngagementProcessStatus.Terminated]: 'Terminated',
    [EngagementProcessStatus.Completed]: 'Completed',
};